export const RemoteTableCard = {
  tag: 'button',
  type: 'button',
  flow: 'y',
  gap: 'V',
  padding: 'A',
  round: 'radiusControl',
  background: 'overlay',
  cursor: 'pointer',
  textAlign: 'left',
  // Fill-contrast hover (was a `borderColor: 'title'` swap on top of an
  // already-redundant `line` border — border-habit sweep, design-direction.md
  // §8). Uses the `hover` state token, NOT `overlayStrong`: §4.3/§8.1 makes
  // overlayStrong a sheet WASH, never a state fill — it inverted active states
  // on light — so states take `hover`/`selected`. The `designLanguageLocks`
  // `overlaystrong-as-state` rule enforces exactly this and caught the first
  // pass of this line.
  ':hover': { background: 'hover' },
  transition: 'background 150ms ease',

  onClick: (e, el, s) => {
    const base = el.parent?.__remoteBasePath || '/data/external'
    const target = el.call('makeRemoteUrl', base, { slug: s.slug, table: s.name })
    const root = el.call('findRouteRoot', el) || el.getRoot()
    if (root) el.router(target, root)
  },

  TopRow: {
    flow: 'x',
    align: 'center space-between',
    gap: 'Z',
    Name: {
      tag: 'span',
      fontSize: 'A',
      fontWeight: '700',
      color: 'title',
      text: (el, s) => s.name
    },
    ColumnCount: {
      padding: 'V Z',
      round: 'radiusPill',
      background: 'overlayStrong',
      color: 'caption',
      fontSize: 'Y1',
      fontWeight: '700',
      text: (el, s) => `${(s.columns || []).length} cols`
    }
  },

  ColumnPreview: {
    tag: 'p',
    fontSize: 'Y2',
    color: 'caption',
    margin: '0',
    lineHeight: '1.4',
    lineClamp: '2',
    text: (el, s) => {
      const cols = s.columns || []
      return (
        cols
          .map((c) => c.name)
          .slice(0, 8)
          .join(', ') + (cols.length > 8 ? '…' : '')
      )
    }
  }
}
